// /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/pages/EnergyAdvisory.tsx

import HeroBanner from "../../components/HeroBanner.tsx";
import HeroParallax from "../../components/HeroParallax.tsx";
import Counter from "../../components/Counter.tsx";
import Showcase from "../../components/Showcase.tsx";
import PartnerGrid from "../../components/PartnerGrid.tsx";
import CareersBanner from "../../components/CareersBanner.tsx";
import ESG from "../../components/ContentCard.tsx";
import ContactPerson from "../../components/ContactPerson.tsx";
import AnchorMenu from "../../components/AnchorMenu.tsx";
import { useLanguage } from "../../lang/index.lang.tsx";

const EnergyAdvisory = () => {
  const { t } = useLanguage();

  return (
    <>
      <AnchorMenu
        title={t("services.energy-advisory.title")}
        titleLink="#services"
        items={[
          { id: "Title", label: t("counter.heading.title"), anchor: "Counter" },
          { id: "2", label: t("anchor.whatWeDo"), anchor: "AllServices" },
          { id: "3", label: t("navigation.career"), anchor: "Careers" },
          { id: "4", label: t("services.heading.partner"), anchor: "Partner" },
          { id: "5", label: t("anchor.contactPersons"), anchor: "ContactPersons" },
          { id: "6", label: t("home.esg.heading.subtitle"), anchor: "esg" },
        ]}
      />
    <section id="Services">
      <HeroParallax        
        header={t("services.energy-advisory.header")}
        welcome={t("services.energy-advisory.welcome")}
        title={t("services.energy-advisory.description.short")}
        description={t("services.energy-advisory.description.long")}
        buttonText={t("common.learnMore")}
        buttonLink=""
        image="/images/EST-767664.jpg"
      />
    </section>

      
       
      

      <section id="Counter">
        <Counter
          items={[
            {
              key: "savedCO2",
              endValue: 1250,
              prefix: "",
              suffix: " t CO₂",
            },
            {
              key: "retrofitConcepts",
              endValue: 50,
              prefix: "",
              suffix: "+",
            },
            {
              key: "industriesServed",
              endValue: 10,
              prefix: "",
              suffix: "+",
            },
            {
              key: "energyCertificates",
              endValue: 50,
              prefix: "",
              suffix: "+",
            },
          ]}
          sectionTitle={t("services.energy-advisory.title")}
          mainTitle={t("counter.heading.title")}
        />
      </section>

      <section id="AllServices">
        <Showcase
          heading={{
            subtitle: t("services.energy-advisory.title"),
            title: t("services.energy-advisory.header"),
            explore: t("services.energy-advisory.explore"),
          }}
          items={[
            {
              id: 1,
              title: t("services.renovation-roadmap.title"),
              subtitle: t("services.renovation-roadmap.description.short"),
              description: t("services.renovation-roadmap.description.long"),
              link: "",
            },
            {
              id: 2,
              title: t("services.energy-performance-certificate.title"),
              subtitle: t("services.energy-performance-certificate.description.short"),
              description: t("services.energy-performance-certificate.description.long"),
              link: "",
            },     
            {
              id: 3,
              title: t("services.building-simulation.title"),
              subtitle: t("services.building-simulation.description.short"),
              description: t("services.building-simulation.description.long"),
              link: "",
            },
            {
              id: 4,
              title: t("services.life-cycle-analysis.title"),
              subtitle: t("services.life-cycle-analysis.description.short"),
              description: t("services.life-cycle-analysis.description.long"),
              link: "",
            },           
            {
              id: 5,
              title: t("services.heating-energy-services.title"),
              subtitle: t("services.heating-energy-services.description.short"),
              description: t("services.heating-energy-services.description.long"),
              link: "",
            },           
            {
              id: 6,
              title: t("services.energy-refurbishment.title"),
              subtitle: t("services.energy-refurbishment.description.short"),
              description: t("services.energy-refurbishment.description.long"),
              link: "/services/design-build",
            },
          ]}
          learnMoreText={t("services.heading.learnMore")}
        />
      </section>

      <section id="Careers">
        <CareersBanner
          image="/images/EST-6372937.jpg"
          title={t("home.heroBanner.title")}
          description={t("home.heroBanner.description")}
          buttonText={t("home.heroBanner.buttonText")}
          buttonLink="/careers"
        />
      </section>

      <section id="Partner">
        <PartnerGrid />
      </section>

      <section id="ContactPersons">
        <ContactPerson
          heading={{
            subtitle: t("services.energy-advisory.department"),
            title: t("services.heading.contact-person"),
          }}
          employeeIds={["YS"]}
        />
      </section>

      <section id="esg">
        <ESG
          heading={{
            title: t("home.esg.heading.title"),
            description: t("home.esg.heading.description"),
          }}
          data={[
            {
              id: 1,
              title: t("home.esg.s.title"),
              description: t("home.esg.s.description"),
              image: "/images/EST-1385648186.jpg",
              category: t("home.esg.s.category"),
              buttonText: t("home.esg.s.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 2,
              title: t("home.esg.e.title"),
              description: t("home.esg.e.description"),
              image: "/images/EST-599972772.jpg",
              category: t("home.esg.e.category"),
              buttonText: t("home.esg.e.buttonText"),
              buttonLink: "/about",
            },
            {
              id: 3,
              title: t("home.esg.g.title"),
              description: t("home.esg.g.description"),
              image: "/images/EST-12499784456.jpg",
              category: t("home.esg.g.category"),
              buttonText: t("home.esg.g.buttonText"),
              buttonLink: "/about",
            },
          ]}
        />
      </section>
    </>
  );
};

export default EnergyAdvisory;
